import { Download } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { CSVDownloadButton } from '@/components/CSVDownloadButton';
import { useGetAudienceUsers } from '@/hooks/useGetAudienceUsers';
import { Audience } from '@/services/AudiencesService';

interface AudienceSizeProps {
  audience: Pick<Audience, 'id' | 'audience_size'>;
}

export function AudienceSize({ audience }: AudienceSizeProps) {
  const { t } = useTranslation('translation', {
    keyPrefix:
      'pages.Behaviors.AudiencesCreate.components.AudienceSliderControl',
  });
  const { audienceUsers, getAudienceUsers } = useGetAudienceUsers(audience.id);

  const data =
    audienceUsers?.map((audienceUser) => ({
      user_id: audienceUser.crm.userProfileId,
      phone: audienceUser.crm.phone,
    })) ?? [];

  const headers = [
    { label: 'user_id', key: 'user_id' },
    { label: 'phone', key: 'phone' },
  ];

  async function handleDownload() {
    await getAudienceUsers();
  }

  return (
    <div>
      <div className="flex flex-row justify-between gap-2">
        <p className="text-sm text-gray-600">{t('audienceSizeLabel')}</p>
        <div className="text-w-10 flex flex-row items-center gap-2 font-semibold text-blue-600 hover:underline">
          {Number(audience.audience_size)}
          <CSVDownloadButton
            data={data}
            headers={headers}
            onDownload={handleDownload}
          >
            <Download className="h-4 w-4" />
          </CSVDownloadButton>
        </div>
      </div>
    </div>
  );
}
